export const pageUtilitiesMixin = {
    methods: {
        isScrolledToBottom: function (el) {
            // NOTE: scrollTop is fractional, while scrollHeight and clientHeight are
            // not, so without this Math.abs() trick then sometimes the result won't
            // work because scrollTop may not be exactly equal to el.scrollHeight -
            // el.clientHeight when scrolled to the bottom.
            return Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) < 1
        },
        copyToClipboard: async function (text) {
            if (!text || typeof text !== 'string' || text.trim() === '') {
                return;
            }

            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(text);
                    return true;
                } catch (e) {
                    console.warn("Clipboard API failed, falling back", e);
                }
            }
    
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();

            const success = document.execCommand("copy");
            document.body.removeChild(textarea);

            return success;
        }
    }
};